// 날짜/시간 포맷터
export const formatDateTime = (dateTime, locale = 'ko-KR') => {
  if (!dateTime) return '-'
  
  return new Date(dateTime).toLocaleString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
}

// 세션 ID 포맷터 (보안을 위한 축약)
export const formatSessionId = (sessionId) => {
  if (!sessionId) return '-'
  return sessionId.length > 8 ? sessionId.substring(0, 8) + '...' : sessionId
}

// 숫자 포맷터
export const formatNumber = (number, locale = 'ko-KR') => {
  if (typeof number !== 'number' || isNaN(number)) return '0'
  return number.toLocaleString(locale)
}

// 컨텐츠 타입 라벨 매핑
export const CONTENT_TYPE_LABELS = {
  'EVENT': '이벤트',
  'EXHIBITION': '전시',
  'NEWS': '뉴스',
  'SPECIAL': '스페셜',
  'ARTIST': '아티스트',
  'ARTWORK': '작품'
}

export const getContentTypeLabel = (type) => {
  return CONTENT_TYPE_LABELS[type] || type
}

// 컨텐츠 타입 옵션 (셀렉트 박스용)
export const CONTENT_TYPE_OPTIONS = [
  { value: '', label: '전체' },
  { value: 'EVENT', label: '이벤트' },
  { value: 'EXHIBITION', label: '전시' },
  { value: 'NEWS', label: '뉴스' },
  { value: 'SPECIAL', label: '스페셜' },
  { value: 'ARTIST', label: '아티스트' },
  { value: 'ARTWORK', label: '작품' }
]